import * as React from 'react';
import type { SVGProps } from 'react';
const FilePdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#prefix__a)">
      <path
        fill="#EA3434"
        fillRule="evenodd"
        d="M2.88 0A2.88 2.88 0 0 0 0 2.88v18.24A2.88 2.88 0 0 0 2.88 24h18.24A2.88 2.88 0 0 0 24 21.12V2.88A2.88 2.88 0 0 0 21.12 0zm1.53 15.14q.147.1.484.1.339 0 .484-.1a.42.42 0 0 0 .183-.255q.036-.164.037-.336v-1.192h1.169q.384 0 .776-.137.393-.145.722-.418a2.143 2.143 0 0 0 .75-1.674q0-.564-.21-.983a2.1 2.1 0 0 0-.54-.7 2.276 2.276 0 0 0-1.489-.564H4.903q-.337 0-.484.1a.42.42 0 0 0-.182.264 1.4 1.4 0 0 0-.037.327v4.968q0 .172.037.336.036.164.173.264m2.366-3.166H5.598v-1.71h1.169q.256 0 .448.109a.8.8 0 0 1 .31.3.9.9 0 0 1 .11.446q0 .3-.137.491a.78.78 0 0 1-.33.282 1 1 0 0 1-.392.082m3.048 3.166q.147.1.466.1h1.626q.676 0 1.242-.246a3.2 3.2 0 0 0 1.005-.673q.43-.436.667-1.019.238-.591.238-1.274 0-.673-.238-1.246a3 3 0 0 0-.667-1 3.1 3.1 0 0 0-.995-.665 3.1 3.1 0 0 0-1.224-.236h-1.645q-.337-.009-.484.09a.42.42 0 0 0-.183.265 1.4 1.4 0 0 0-.036.327v4.977q0 .18.046.345.044.155.182.255m2.12-1.292h-.96v-3.584h.95a1.7 1.7 0 0 1 1.517.873q.228.41.228.928 0 .519-.228.919-.229.4-.621.637a1.74 1.74 0 0 1-.886.227m4.055 1.301q.147.09.475.091.347 0 .485-.091a.42.42 0 0 0 .182-.255q.037-.164.037-.336v-1.92h1.863q.192 0 .33-.027a.34.34 0 0 0 .228-.146q.082-.127.082-.418 0-.3-.082-.428a.34.34 0 0 0-.229-.155 1.7 1.7 0 0 0-.32-.027h-1.872v-1.173h1.799q.182 0 .338-.028a.43.43 0 0 0 .264-.182q.1-.145.101-.473 0-.345-.1-.491a.36.36 0 0 0-.247-.173 1.5 1.5 0 0 0-.338-.036h-2.493q-.402 0-.557.145-.156.146-.156.546v4.977q0 .173.028.336.036.164.182.264"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default FilePdf;

